export const designTokens = {
  colors: {
    primary: "#00264D",
    primaryHover: "#001D3D",

    accent: "#D79A1E",
    accentSoft: "#FFF4D6",

    page: "#FAF8F3",
    surface: "#FFFFFF",
    surfaceMuted: "#F7F5F0",

    textPrimary: "#071226",
    textSecondary: "#667085",
    border: "#E4E1D9",

    success: "#237A57",
    warning: "#B7791F",
    error: "#B42318",

    advertisementBride: "#DB2777",
    advertisementBridegroom: "#1D4ED8",
  },

  radius: {
    input: "10px",
    card: "16px",
    section: "18px",
  },

  shadow: {
    card: "0 4px 18px rgba(15, 23, 42, 0.06)",
  },
};

export const designClasses = {
  page: "bg-[#FAF8F3]",

  surface: "bg-white",
  surfaceMuted: "bg-[#F7F5F0]",

  textPrimary: "text-[#00264D]",
  textDark: "text-[#071226]",
  textSecondary: "text-[#667085]",

  bgPrimary: "bg-[#00264D]",
  hoverPrimary: "hover:bg-[#001D3D]",

  textAccent: "text-[#D79A1E]",
  bgAccent: "bg-[#D79A1E]",
  bgAccentSoft: "bg-[#FFF4D6]",

  textSuccess: "text-[#237A57]",

  border: "border-[#E4E1D9]",

  primaryButton:
    "bg-[#00264D] text-white hover:bg-[#001D3D]",

  secondaryButton:
    "border border-[#00264D] text-[#00264D] hover:bg-[#00264D] hover:text-white",

  statusWarning:
    "border border-[#D79A1E]/30 bg-[#FFF4D6] text-[#071226]",

  statusReview:
    "border border-[#00264D]/15 bg-[#F7F5F0] text-[#071226]",

  statusSuccess:
    "border border-[#237A57]/20 bg-white text-[#071226]",

  statusError:
    "border border-[#B42318]/20 bg-white text-[#071226]",

  progressTrack:
    "bg-[#E4E1D9]",

  progressWarning:
    "bg-[#D79A1E]",

  progressSuccess:
    "bg-[#237A57]",

  statusTitle:
    "text-[#071226] font-semibold",

  statusText:
    "text-[#667085]",

  card:
    "rounded-2xl border border-[#E4E1D9] bg-white shadow-sm",

  advertisementEditor:
    "rounded-xl border border-[#E4E1D9] bg-white px-4 py-4",

  advertisementPreview:
    "rounded-xl border border-[#E4E1D9] bg-[#F7F5F0] p-4",

  advertisementHeading:
    "text-lg font-bold",

  advertisementBrideHeading:
    "text-[#DB2777]",

  advertisementBridegroomHeading:
    "text-[#1D4ED8]",

  advertisementBody:
    "mt-2 text-sm leading-relaxed text-[#071226]",

  advertisementEditorBody:
    "mt-2 w-full resize-y border-0 bg-transparent p-0 text-[15px] leading-6 text-[#071226] outline-none focus:ring-0",

  fieldLabel:
    "mb-1 block text-sm font-medium text-[#071226]",

  fieldHelper:
    "mt-1 text-xs text-[#667085]",

  fieldInlineText:
    "text-sm text-[#071226]",

  readOnlyField:
    "w-full cursor-not-allowed bg-[#F7F5F0]",

  formSectionCard:
    "rounded-xl border border-[#E4E1D9] bg-white p-4",

  formSectionHeading:
    "mb-4 border-b border-[#E4E1D9] pb-2 text-lg font-semibold text-[#00264D]",
};